import makeBlockie from 'ethereum-blockies-base64';
import { Box } from '@blockanalitica/ui';
import { useTheme } from 'styled-components';
import { resolveThemeVariable } from '@blockanalitica/ui';
import type { Size } from '@blockanalitica/ui/package/types/src/theme/types';

type BlockieProps = {
  address: string;
  imgSize?: Size | number;
};

export default function Blockie({
  address,
  imgSize = 32,
  ...rest
}: BlockieProps) {
  const theme = useTheme();
  return (
    <Box
      as="img"
      borderRadius="50%"
      // @ts-ignore
      src={makeBlockie(address)}
      width={
        typeof imgSize === 'number'
          ? imgSize + 'px'
          : resolveThemeVariable<Size | string>(imgSize, theme.sizes)
      }
      height={
        typeof imgSize === 'number'
          ? imgSize + 'px'
          : resolveThemeVariable<Size | string>(imgSize, theme.sizes)
      }
      {...rest}
    />
  );
}
